

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppAdmin from './admin/AppAdmin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppAdmin />
  </React.StrictMode>
);

